import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('GamedDataUsage').create(({ theme }) => ({
  root: {
    marginTop: '16px',
    display: 'flex',
    position: 'relative',
    width: '92.5%',
    flexDirection: 'column',
    padding: '24px 20px',
    background: '#161617',
    borderRadius: '12px',
    zIndex: '1',
    gap: '12px',
    marginBottom: 'calc(52px + 4vh)',
  },

  buttonShadow: {
    position: 'fixed',
    height: '150px',
    zIndex: 3,
    width: '100%',
    bottom: '0px',
    backgroundImage: 'linear-gradient(to top, rgb(0, 0, 0) 0%, rgba(0, 0, 0, .2) 75%, rgba(0, 0, 0, 0) 100%)',
    pointerEvents: 'none',
  },

  contentWrapper: {
    zIndex: 5,
  },

  blackBackground: {
    position: 'absolute',
    background: 'black',
    height: '100vh',
    width: '100vw',
  },

  headingWrapper: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    gap: '12px',
    zIndex: 5,
    h1: {
      fontWeight: 450,
      fontSize: theme.sizes.texts.fontSize.l,
      lineHeight: theme.sizes.texts.lineHeight.xl,

      color: theme.colors.text.primary,
    },
  },

  paragraph: {
    fontSize: '13px',
    fontWeight: 200,
    zIndex: 5,
    lineHeight: theme.sizes.texts.lineHeight.s,

    color: theme.colors.text.secondary,
  },

  whatWeCollect: {
    marginTop: '12px',
    textTransform: 'uppercase',
    fontWeight: 300,
    fontSize: '13px',
    lineHeight: theme.sizes.texts.lineHeight.s,

    zIndex: 5,
    color: theme.colors.text.secondary,
  },

  policy: {
    fontWeight: 350,
    fontSize: '13px',
    zIndex: 5,
    lineHeight: '18px',
    color: theme.colors.text.secondary,

    a: {
      color: theme.colors.text.link,
      textDecoration: 'none',
      cursor: 'pointer',
    },
  },

  buttonWrapper: {
    width: '100%',
    zIndex: 7,
    position: 'fixed',
    left: '0',
    bottom: '12px',
    display: 'flex',
    justifyContent: 'center',
  },

  button: {
    height: '52px',
    width: '92.5%',
    position: 'relative',
    boxShadow: 'none',
    background: theme.colors.background.secondary,
    fontSize: theme.sizes.texts.fontSize.m,
    fontWeight: 460,
  },
}))
